import config from '../config';
import { CookieKeys, getRawCookie } from '../hooks/useCookie';

type VisitorGeo = {
  country: string | null;
  region: string | null;
};

const LOOKUP_TIMEOUT_MS = 1000;

const fetchGeo = async (): Promise<VisitorGeo> => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), LOOKUP_TIMEOUT_MS);
  try {
    const response = await fetch(`${config.mktUrl}/api/geo`, { signal: controller.signal });
    const { country, region } = await response.json();
    return {
      country: typeof country === 'string' ? country : null,
      region: typeof region === 'string' ? region : null,
    };
  } catch {
    return { country: null, region: null };
  } finally {
    clearTimeout(timeout);
  }
};

let geoLookup: Promise<VisitorGeo> | undefined;

export const fetchVisitorGeo = () => {
  // Keep only full answers, like lab, which serves /api/geo no-store unless both lookups resolve
  geoLookup ??= fetchGeo().then((geo) => {
    if (!geo.country || !geo.region) {
      geoLookup = undefined;
    }
    return geo;
  });
  return geoLookup;
};

export const resolveVisitorCountry = async () =>
  getRawCookie(CookieKeys.COUNTRY) || (await fetchVisitorGeo()).country;
